export const formatUserDisplayName = user => {
  if (!user) return '-';
  if (typeof user === 'string') return user || '-';

  const fullName = [user.firstName, user.lastName].filter(Boolean).join(' ');
  return fullName || user.email || '-';
};
